import { render, staticRenderFns } from "./UploadDocumentPreference.vue?vue&type=template&id=c9ff88e8"
import script from "./UploadDocumentPreference.vue?vue&type=script&lang=js"
export * from "./UploadDocumentPreference.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentPreference.vue?vue&type=style&index=0&id=c9ff88e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports